// frontend/src/services/authService.js
import api from './api';

export const login = async (username, password) => {
  try {
    const response = await api.post('/auth/login', { username, password });
    localStorage.setItem('token', response.data.token);
    return response.data.user;
  } catch (error) {
    throw error.response ? error.response.data : new Error('การเชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  window.location.href = '/login';
};

export const checkAuth = async () => {
  try {
    const response = await api.get('/auth/profile');
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('การเชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
  }
};

export const updateProfile = async (profileData) => {
  try {
    const response = await api.put('/auth/profile', profileData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('การเชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
  }
};

export const changePassword = async (currentPassword, newPassword) => {
  try {
    const response = await api.put('/auth/change-password', { currentPassword, newPassword });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('การเชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
  }
};